// PRIMARY: the daemon's own IPFS proxy, the same one the WHATIFX marketplace uses.
// It tries the AtomicHub resizer first, then dweb.link / ipfs.io / nftstorage.link /
// w3s.link / 4everland, caches to disk and puts a dead gateway on cooldown -- so one
// gateway going down is invisible here. Pointing at a single public gateway is what
// broke images on this site: pinata stopped answering entirely and wecan.dev returns
// 522, and with both dead every NFT image 404'd.
export const ipfsGateway = "https://api.rewardsinwhatif.app/ipfs/";
export const resolveIpfsUrl = (hash) => hash ? `${ipfsGateway}${hash}` : null;
export const FIREBASE_PROJECT_ID = "whatif-battle-for-riches";
export const API_BASE_URL = `https://us-central1-${FIREBASE_PROJECT_ID}.cloudfunctions.net`;
export const BASE_MAX_STAMINA = 100;
export const TOKEN_CONTRACT = 'yoyinsoly214'; // This remains the default contract
export const BLEND_CONTRACT = 'whatifblends';
export const STORE_CONTRACT = 'whatifstores';
export const TOKENS = ['WAX', 'WHATIF', 'FIREMAN', 'PUZZL', 'WTFWUF', 'WTFBILL', 'WHATIFX', 'TESTERU', 'XMASZS'];
export const SUPPORTED_COLLECTIONS = [
  'whatifreward',
  'idaretodream',
  'waxstation21',
  'syndicates21',
  'pixeljourney',
  'cleanupcentr',
  'pantheon',
  'alien.worlds',
  'planetdefnft',
  'futuresrelic',
  'facings',
  'mlb.topps',
  'taco',
  'pigmentiawax',
  'wedare2dream'
];
export const tokenContracts = {
  'WAX': 'eosio.token',
  'WHATIF': 'yoyinsoly214',
  'FIREMAN': 'yoyinsoly214',
  'PUZZL': 'yoyinsoly214',
  'WTFWUF': 'yoyinsoly214',
  'WTFBILL': 'yoyinsoly214',
  'WHATIFX': 'yoyinsoly214',
  'TESTERU': 'yoyinsoly214',
  'XMASZS': 'yoyinsoly214',
};
export const tokenDecimals = {
  'WAX': 8, 'WHATIF': 8, 'FIREMAN': 5, 'PUZZL': 8, 'WTFWUF': 8, 'WTFBILL': 8,
  'WHATIFX': 8, 'TESTERU': 8, 'XMASZS': 6,
};
export const buildingConfigClient = {
  'forge': {
    name: 'Forge', boostType: 'MP Boost', boostPerLevel: 2.5, upgradeToken: 'FIREMAN', description: 'Increases the MP of all gang members.'
  },
  'workshop': {
    name: 'Workshop', boostType: 'Speed Boost', boostPerLevel: 2.5, upgradeToken: 'WTFWUF', description: 'Boosts the Speed of all members.'
  },
  'barracks': {
    name: 'Barracks', boostType: 'Stamina Boost', boostPerLevel: 5, upgradeToken: 'WHATIF', description: 'Increases the maximum daily Stamina for all members.'
  },
  'bastion': {
    name: 'Bastion', boostType: 'Base MP Boost', boostPerLevel: 2.5, upgradeToken: 'PUZZL', description: 'Increases the Base MP of all gang members.'
  },
  'observatory': {
    name: 'Observatory', boostType: 'Points Gain', boostPerLevel: 2.5, upgradeToken: 'WTFBILL', description: 'Increases the Daily & Seasonal Points Dungeon Runs.'
  },
  'scribeLibrary': {
    name: 'Scribe\'s Library', boostType: 'XP Gain', boostPerLevel: 2.5, upgradeToken: 'XMASZS', description: 'Speeds up player leveling for all gang members.'
  },
  'altarOfFortune': {
    name: 'Altar of Fortune', boostType: 'NFT Gain Chance', boostPerLevel: 0.5, upgradeToken: 'WHATIFX', description: 'Increases the chance to win a pack in the daily rewards.'
  },
  'watchtower': {
    name: 'Watchtower', boostType: 'Vault APR Boost', boostPerLevel: 0.25, upgradeToken: 'TESTERU', description: 'Enhances token rewards from the WHATIF Vault.'
  }
};
export const ATOMIC_API_ENDPOINTS = [
  "https://wax-atomic-api.eosphere.io",
  "https://wax.api.atomicassets.io",
  "https://atomic.wax.3dkrender.com",
  "https://atomic.wax.eosrio.io",
  "https://aa.neftyblocks.com",
  "https://aa.dapplica.io"
];
export const getUpgradeCostClient = (level, token) => {
  const baseCost = {
    'FIREMAN': 50000, 'WTFWUF': 10000, 'WHATIF': 2000000,
    'PUZZL': 1800, 'WTFBILL': 2, 'XMASZS': 10,
    'WHATIFX': 500, 'TESTERU': 4000
  };
  if (!baseCost[token]) return Infinity;
  return baseCost[token] * Math.pow(2, level);
};
export const Client = (level) => {
  const baseCooldown = 24; // 24 hours
  const maxCooldown = 16 * 24; // 16 days in hours
  const calculatedCooldown = baseCooldown * Math.pow(2, level);
  return Math.min(calculatedCooldown, maxCooldown);
};
export const itemTemplates = {
  // Fireman NFTs
  878281: {
    rarity: "Mystic",
    attack: 1080
    , name: "Fireheart Mystic", img: "QmbKzDT2UBrwBBLyb1HyGWfjX942j3KpaRv4pj8ebwtVvE"
  },
  878279: {
    rarity: "Legendary",
    attack: 360
    , name: "Ember Godking", img: "QmTCadgYZbov2sKkxnVKA9XNo9M5ZrJb5GtAuawoEfkSTK"
  },
  878274: {
    rarity: "Epic",
    attack: 120
    , name: "WHATIF Flame Lord ", img: "QmQvpwvk8ZefPipuWkTfYAQVtPEJKL4mHmMQBarQa7tyBf"
  },
  878273: {
    rarity: "Rare",
    attack: 40
    , name: "Inferno Titan ", img: "QmSyD332XUuPeM6cBSzCoojKSbL8sofNbSEH3rLfHQb4XF"
  },
  878270: {
    rarity: "Uncommon",
    attack: 15
    , name: "Blaze Warden", img: "QmRtXQJCNM4uzLFkrf5mS6rEoerJFZXtKGBmBgntQb45hk"
  },
  878268: {
    rarity: "Common",
    attack: 5
    , name: "WHATIF Flameborn", img: "QmXFHqcVLxVUwEoRD7N47NotzMB1QYJgCsVRs7KRS1XWXg"
  },
  880461: {
    rarity: "Mystic",
    attack: 160
    , name: "Phoenix ", img: "QmUs5LutY92UPaYW3w5hDiwTNskZLB43J3P5VFWfGqjcmz"
  },
  880460: {
    rarity: "Legendary",
    attack: 80
    , name: "Serpent", img: "QmccVjDpw7zETGqJ63qZbUHjWmjzsRVA9v667Yv9c43CHW"
  },
  880456: {
    rarity: "Epic",
    attack: 40
    , name: "Dragon", img: "QmRP7oMxqYDNM9jP2TuK7nBwqGBZCrHGDYzD4w8itMhgek"
  },
  880455: {
    rarity: "Rare",
    attack: 20
    , name: "Chimera", img: "Qmc5Gst8fg5iWbWidyNqWtTM9LGQftX197eC4XWuzbu3MP"
  },
  880454: {
    rarity: "Uncommon",
    attack: 10
    , name: "Kraken", img: "QmUDkeeou1JbsvunKZzSAs7kadW3Fu8wvadBpu54TiPJ9x"
  },
  880453: {
    rarity: "Common",
    attack: 5
    , name: "Cyclops", img: "QmPhvVEkmALoUiEK6smMh5HC4LzXkKHknXohQoQgDrx19n"
  },
  881084: {
    rarity: "Mystic",
    attack: 224
    , name: "Phoenix + WTFWUF", img: "QmZKGRq5fPezvqiMgrbfpdrhk3MYJYcqaVgasaSEYBPKrk"
  },
  881083: {
    rarity: "Legendary",
    attack: 112
    , name: "Serpent + WTFWUF", img: "Qmey8Kdo9pmSAPJJWdWmzsVL8hYJuXGoc9YTB4Sbg6BeMu"
  },
  881082: {
    rarity: "Epic",
    attack: 56
    , name: "Dragon + WTFWUF", img: "QmYDwXrsrTkcAnoPwzEfTybMcZGoMLvphfy92a4oetPedM"
  },
  881081: {
    rarity: "Rare",
    attack: 28
    , name: "Chimera + WTFWUF ", img: "Qma7byhoDvyC2FGFF4z4e2YeXGLaEKsTHiRXex4Nf24VWM"
  },
  881080: {
    rarity: "Uncommon",
    attack: 14
    , name: "Kraken + WTFWUF", img: "QmWKGghWyKTPEgGGaEwWfm5b68i21sEHLsjM74p2ZBaR3h"
  },
  881079: {
    rarity: "Common",
    attack: 7
    , name: "Cyclops + WTFWUF", img: "QmSKUYjCto31ptqvmN4GoN9cacrPqjgkqcXWk5M8BeyoBa"
  },
  884624: {
    rarity: "Mystic",
    attack: 1304
    , name: "FIREMAN PHOENIX + WTFWUF", img: "QmaJGHVpJrkUxJ4zoZ3FzygybQpS91VTUu5ThdGoJhQvxc"
  },
  884627: {
    rarity: "Ascended Mystic",
    attack: 2608
    , name: "Ascended FIREMAN PHOENIX + WTFWUF", img: "QmduJYtaxqQ3sxKtN168hSb5oWLtpPRnjGaMWZcNwCvXLK"
  },
  // Round 3 (Reforged): 8x the Round 2 NFT each replaces, same art
  910139: {
    rarity: "Mystic",
    attack: 1280
    , name: "Phoenix", img: "QmUs5LutY92UPaYW3w5hDiwTNskZLB43J3P5VFWfGqjcmz"
  },
  910140: {
    rarity: "Legendary",
    attack: 640
    , name: "Serpent", img: "QmccVjDpw7zETGqJ63qZbUHjWmjzsRVA9v667Yv9c43CHW"
  },
  910141: {
    rarity: "Epic",
    attack: 320
    , name: "Dragon", img: "QmRP7oMxqYDNM9jP2TuK7nBwqGBZCrHGDYzD4w8itMhgek"
  },
  910142: {
    rarity: "Rare",
    attack: 160
    , name: "Chimera", img: "Qmc5Gst8fg5iWbWidyNqWtTM9LGQftX197eC4XWuzbu3MP"
  },
  910143: {
    rarity: "Uncommon",
    attack: 80
    , name: "Kraken", img: "QmUDkeeou1JbsvunKZzSAs7kadW3Fu8wvadBpu54TiPJ9x"
  },
  910144: {
    rarity: "Common",
    attack: 40
    , name: "Cyclops", img: "QmPhvVEkmALoUiEK6smMh5HC4LzXkKHknXohQoQgDrx19n"
  },
  910133: {
    rarity: "Mystic",
    attack: 1792
    , name: "Phoenix + WTFWUF", img: "QmZKGRq5fPezvqiMgrbfpdrhk3MYJYcqaVgasaSEYBPKrk"
  },
  910134: {
    rarity: "Legendary",
    attack: 896
    , name: "Serpent + WTFWUF", img: "Qmey8Kdo9pmSAPJJWdWmzsVL8hYJuXGoc9YTB4Sbg6BeMu"
  },
  910135: {
    rarity: "Epic",
    attack: 448
    , name: "Dragon + WTFWUF", img: "QmYDwXrsrTkcAnoPwzEfTybMcZGoMLvphfy92a4oetPedM"
  },
  910136: {
    rarity: "Rare",
    attack: 224
    , name: "Chimera + WTFWUF", img: "Qma7byhoDvyC2FGFF4z4e2YeXGLaEKsTHiRXex4Nf24VWM"
  },
  910137: {
    rarity: "Uncommon",
    attack: 112
    , name: "Kraken + WTFWUF", img: "QmWKGghWyKTPEgGGaEwWfm5b68i21sEHLsjM74p2ZBaR3h"
  },
  910138: {
    rarity: "Common",
    attack: 56
    , name: "Cyclops + WTFWUF", img: "QmSKUYjCto31ptqvmN4GoN9cacrPqjgkqcXWk5M8BeyoBa"
  },
  910145: {
    rarity: "Mystic",
    attack: 10432
    , name: "FIREMAN PHOENIX + WTFWUF", img: "QmaJGHVpJrkUxJ4zoZ3FzygybQpS91VTUu5ThdGoJhQvxc"
  },
  910131: {
    rarity: "Ascended Mystic",
    attack: 20864
    , name: "Ascended FIREMAN PHOENIX + WTFWUF", img: "QmduJYtaxqQ3sxKtN168hSb5oWLtpPRnjGaMWZcNwCvXLK"
  },
  // idaretodream NFTs (Attackers with HP Recoup)
  // Support Schema
  883737: {
    rarity: "Common",
    attack: 25,
    hpRecoupPercent: 50
    , name: "Precision Mind", img: "QmRZK6q7pPWzxrGZvoxJ4KFf3ZKwtyspv1gsAgRXh7Wtmq"
  },
  883742: {
    rarity: "Uncommon",
    attack: 50,
    hpRecoupPercent: 50
    , name: "Harmony's Listener", img: "QmfXcCeQDbikbNApstEED3LrrotxRuvCy6H6MGr4U9oCMq"
  },
  883745: {
    rarity: "Rare",
    attack: 100,
    hpRecoupPercent: 50
    , name: "Guardian of Memories", img: "QmaLnkWeTqGfn3PGnLbVcaCC6jPZmgRoTJv8NqqWZrg24p"
  },
  883749: {
    rarity: "Epic",
    attack: 200,
    hpRecoupPercent: 50
    , name: "Weaver of Connections", img: "QmbPY5y3SYEw3Q58mXxDQ1wTjwDRxFxzmWoBAAqhPFpfPZ"
  },
  883753: {
    rarity: "Legendary",
    attack: 400,
    hpRecoupPercent: 50
    , name: "Focus Catalyst", img: "QmepKAmXXDQgb1ck7RNpaLzuQpt3JifURKBUQe1NBgjhAg"
  },
  883758: {
    rarity: "Mystic",
    attack: 800,
    hpRecoupPercent: 50
    , name: "Guardian of the Heart", img: "QmeSgUgRvJdz6ihafQiHwMhsEvHbzrYZeJzoWMQiis1AKd"
  },
  // Inspiration Schema
  883740: {
    rarity: "Common",
    attack: 30,
    hpRecoupPercent: 50
    , name: "Visionary Precision", img: "QmVNYmqeZDZbVMwrTxj2JjjaDbZxMXCbTP37vzih54miFp"
  },
  883743: {
    rarity: "Uncommon",
    attack: 60,
    hpRecoupPercent: 50
    , name: "Echoes of Insight", img: "Qmc1YoK2qGBTcQmySnEb1qVVeNcRzuCWZ2ny4a8NxemgQK"
  },
  883747: {
    rarity: "Rare",
    attack: 120,
    hpRecoupPercent: 50
    , name: "Chronicle of Brilliance", img: "QmeKFCJEbchxsWuLEzKpV11MxqN9fwo9JZiWQHbo7asm9j"
  },
  883750: {
    rarity: "Epic",
    attack: 240,
    hpRecoupPercent: 50
    , name: "Architect of Insight", img: "QmTzmuPoeZxLPbgKmE9oAKPwHdAoCXXNF6J9UW5Neyxecb"
  },
  883752: {
    rarity: "Legendary",
    attack: 480,
    hpRecoupPercent: 50
    , name: "Beacon of Focus", img: "QmUZFrpJnovSM6ux7GLEFuHrAdVRpeWmCEWXbzHVSzxLWM"
  },
  883755: {
    rarity: "Mystic",
    attack: 960,
    hpRecoupPercent: 50
    , name: "Heart of Light", img: "QmWN69PVLiQ379cQQDvdBTopmKm87UzLmbZYgaVDubmREi"
  },
  // Encouragement Schema
  883741: {
    rarity: "Common",
    attack: 1760,
    hpRecoupPercent: 50
    , name: "Champions of Precision", img: "QmdC9pSD4w6VjdowSedRQ1agJUDTviaDAjZ3LgptApG3AW"
  },
  883744: {
    rarity: "Uncommon",
    attack: 3520,
    hpRecoupPercent: 50
    , name: "Sonic Champions", img: "QmXDtUKRXM1uH6mesiMacxiqJXoa3pKfnXuXZ7inqm3jgi"
  },
  883748: {
    rarity: "Rare",
    attack: 7040,
    hpRecoupPercent: 50
    , name: "Memory’s Luminaries", img: "QmYsxU8cJHpcfqNeq86gXVCTHpHMFYGUH55aDRwg4ixU6w"
  },
  883751: {
    rarity: "Epic",
    attack: 14080,
    hpRecoupPercent: 50
    , name: "Masters of Patterns", img: "QmcpydgqoEYvEyQ171RuQiQSWgv4P6CXrhUrVcsYCai6Hq"
  },
  883754: {
    rarity: "Legendary",
    attack: 28160,
    hpRecoupPercent: 50
    , name: "Champions of Concentration", img: "Qmb5WNqo1tYszkzU78DVxFqeF6zutLmmQtkPcMJ57z2KFm"
  },
  883756: {
    rarity: "Mystic",
    attack: 56320,
    hpRecoupPercent: 50
    , name: "Heartbound Allies", img: "QmbqFJzPnDLuqFx23rkTfriAzbNfLNoy411KdtfmYE8ZPN"
  },
  // Heroes Schema
  884252: {
    rarity: "Hero",
    attack: 112640,
    hpRecoupPercent: 50
    , name: "Focus Flare ", img: "QmS4N3n1mK9kVx8VCEekbgt5o67crsAQhQPVDhvWJpwJ6W"
  },
  // Focus Flare
  883943: {
    rarity: "Hero",
    attack: 113640,
    hpRecoupPercent: 50
    , name: "Rhythmos", img: "QmWxT8kByaiX6RXHzRFH6KHzfPuToFMfEGBfoSgrdmfH6P"
  },
  // Rhythmos
  883944: {
    rarity: "Hero",
    attack: 114640,
    hpRecoupPercent: 50
    , name: "Soulwave", img: "QmdgbxUQHws1xYwETMbvpaizNtGq9h7jyTjuZ7UGXb5ivj"
  },
  // Soulwave
  883945: {
    rarity: "Hero",
    attack: 115640,
    hpRecoupPercent: 50
    , name: "Chronospark", img: "QmTc535C9dHwerE7tQPxuenx1B6CTMEkaJjuZ61d9icE7r"
  },
  // Chronospark
  883946: {
    rarity: "Hero",
    attack: 116640,
    hpRecoupPercent: 50
    , name: "Cognix", img: "QmPJBZ1UPw5meGtmyJk8Bp46YoRgR6uRJSugFEjp2pzqPt"
  },
  // Cognix
  883947: {
    rarity: "Hero",
    attack: 117640,
    hpRecoupPercent: 50
    , name: "Luminara", img: "QmbkBMXZLFhEh99poh6v2V1F2VfJQvVpHXETWgrvV6FDdW"
  },
  // Luminara
  883948: {
    rarity: "Hero",
    attack: 118640,
    hpRecoupPercent: 50
    , name: "Puzzleforge", img: "QmZWWbRXbywKagpx6Cq56pzU1Eh4W857zDe6aCF8vmTW72"
  },
  // Puzzleforge
  883949: {
    rarity: "Hero",
    attack: 119640,
    hpRecoupPercent: 50
    , name: "Soundspire", img: "QmYdhQ2HSEEny9jWU2fawzCX6Ebb4fQKEF3Jjf6ejeinFE"
  },
  // Soundspire
  883950: {
    rarity: "Hero",
    attack: 120640,
    hpRecoupPercent: 50
    , name: "Novaheart", img: "QmbSR5MTjAmxTMGegpmiNVUk1Yfeb27FLhSxYWUibDE2ZT"
  },
  // Novaheart
  883951: {
    rarity: "Hero",
    attack: 121640,
    hpRecoupPercent: 50
    , name: "Dreambyte", img: "QmfTY2SpYDWR9DrdcpGaNVRBpdySJM9AKiZmxgeAKHTafZ"
  },
  // Dreambyte
  883952: {
    rarity: "Hero",
    attack: 122640,
    hpRecoupPercent: 50
    , name: "Infinitune", img: "QmbDGR51kFuSnRB8BFHonVvqmxqeoXhkyFetGQVQ8BWChq"
  },
  // Infinitune
  883953: {
    rarity: "Hero",
    attack: 123640,
    hpRecoupPercent: 50
    , name: "Modulynx", img: "QmX3u9jX8qHKvY6eB4YbEEuQcHCWcuLSpKrnnJk3CLYt8p"
  },
  // Modulynx
  883954: {
    rarity: "Hero",
    attack: 124640,
    hpRecoupPercent: 50
    , name: "Gridlocke", img: "QmQbFy9j6eZuTHA1d5jQadbASd3XnyZwNRhABuWxx2nLAW"
  },
  // Gridlocke
  883955: {
    rarity: "Hero",
    attack: 125640,
    hpRecoupPercent: 50
    , name: "Sequensa", img: "QmNhNFmbnn2GLz6xbhdYYYWU1U5J6HPWXW4FBqg5Bvf8EH"
  },
  // Sequensa
  883956: {
    rarity: "Hero",
    attack: 126640,
    hpRecoupPercent: 50
    , name: "Aurora Voice", img: "QmbM1HZuAJ6QSucPnKoay4UHGRCf11atJpzGo9J4T7EC6u"
  },
  // Aurora Voice
  883957: {
    rarity: "Hero",
    attack: 127640,
    hpRecoupPercent: 50
    , name: "Lexilume", img: "QmP9AqsiXgqvyC1fEVyxHMhY9GA5wGJLjP3Wt9ZPq4YWtD"
  },
  // Lexilume
  883958: {
    rarity: "Hero",
    attack: 128640,
    hpRecoupPercent: 50
    , name: "Symbolyne", img: "QmUBMe6xPDza5CirVMEbz8A4oVonCDKFGFfSsYn2MmLSSZ"
  },
  // Symbolyne
  883959: {
    rarity: "Hero",
    attack: 129640,
    hpRecoupPercent: 50
    , name: "Kindrith", img: "QmbdQeVUouypa8Nk6eqSVRpewxGXxKH7crWzeEFKoXqtqV"
  },
  // Kindrith
  883960: {
    rarity: "Hero",
    attack: 130640,
    hpRecoupPercent: 50
    , name: "Compathor", img: "QmSy1Mfet7grDxomDFukneLckyuhsL7yNSSHY8MyEtjtrZ"
  },
  // Compathor
  883961: {
    rarity: "Hero",
    attack: 131640,
    hpRecoupPercent: 50
    , name: "Halosent", img: "QmUKQjJeknFCeAULyJRk8YBeW8CMakoUH5DUYw9trmDjXg"
  },
  // Halosent
  883962: {
    rarity: "Hero",
    attack: 132640,
    hpRecoupPercent: 50
    , name: "Sketcha", img: "Qmb3Nk3VeDvTKP41rsqByDXokkU5958d1zsPftVDF5MH2H"
  },
  // Sketcha
  883963: {
    rarity: "Hero",
    attack: 133640,
    hpRecoupPercent: 50
    , name: "Mythospark", img: "QmQph3hpDTiyzHxbfF5qy5a6hdUuv8vkxJeoBVfBwdn2W9"
  },
  // Mythospark
  883964: {
    rarity: "Hero",
    attack: 134640,
    hpRecoupPercent: 50
    , name: "Synaptrix", img: "QmUQgeTuPrmdzjFewxvycHVMmsLcpQBvB7kiWqAcgJkvNv"
  },
  // Synaptrix
  883965: {
    rarity: "Hero",
    attack: 135640,
    hpRecoupPercent: 50
    , name: "Codexa", img: "QmXYFoYVEdy14motGWiyw8xe2GzM5imPKusejUr2XcrnUn"
  },
  // Codexa
  883991: {
    rarity: "Hero",
    attack: 136640,
    hpRecoupPercent: 50
    , name: "Structurion", img: "Qmd6rmePjNah9cxa7FvArj6i6PaLxeyMXbxVhs1XdscLg5"
  },
  // Structurion
  883992: {
    rarity: "Hero",
    attack: 137640,
    hpRecoupPercent: 50
    , name: "Prismyn", img: "QmdaNiv7SLSFxGCx1NADiZGqdvJxiGZPF5FuTp6fgzdWsV"
  },
  // Prismyn
  883993: {
    rarity: "Hero",
    attack: 138640,
    hpRecoupPercent: 50
    , name: "Echochime", img: "QmaYFVuJgbxNMAEmpH8kLKmBzKgzgPb5VSiPDhUKMzpfn9"
  },
  // Echochime
  883994: {
    rarity: "Hero",
    attack: 139640,
    hpRecoupPercent: 50
    , name: "Tactilis", img: "QmYtCDfxcT9Yvz1AdzwhjAvMSKVZU9DQJ1Yd4qqqEyjTr1"
  },
  // Tactilis
  883995: {
    rarity: "Hero",
    attack: 140640,
    hpRecoupPercent: 50
    , name: "PUZZLUM", img: "QmTKgrrFfnSD5QsUjF833pHoxHUhtRSG5fR9M6AGYWFCCb"
  },
  // PUZZLUM

  // Deed NFTs
  834331: {
    rarity: "Common",
    hp: 50
    , name: "Blueprint specs", img: "QmWvGFHboVZC3CN6KZyv6hYsQXtkAchi2tiFDiPHDLQwSo"
  },
  834332: {
    rarity: "Rare",
    hp: 100
    , name: "Blueprint Layout", img: "QmeTk94GwjEJHv2nXTmPUxGZx2LbUrHk7Cb6X3nM1QYhMn"
  },
  834333: {
    rarity: "Epic",
    hp: 200
    , name: "WHATIF Rewards Steel Beam", img: "QmcCkieLeVPeqiNSeT43WXKmfAuQX9jsukrMLstPWRFqpE"
  },
  834345: {
    rarity: "Legendary",
    hp: 400
    , name: "WHATIF Deeds Foundation", img: "QmUnVRQJGma6pUzZbTcBiDDfrv67y1E5y7m1sQCytdTD9q"
  },
  834391: {
    rarity: "Mystic",
    hp: 500
    , name: "Dan Deed", img: "QmQZcVTBU2CgY1UVsBMNfeuyVbDBH5SK4HcvCBh89MG4tH"
  },
  818455: {
    rarity: "Common",
    hp: 1000
    , name: "WTF It's A Blue Bill", img: "QmXSygtvsrumGaDC3oFfhsJUJMjV9hop7nhdTPC3yNaXo4"
  },
  818254: {
    rarity: "Common",
    hp: 1000
    , name: "The House That WUF Built", img: "Qmc8UxLcVKMATaKeFdx4tk1NZVNAPXDcHSjBszeWKRnXuh"
  },
  811270: {
    rarity: "Common",
    hp: 1000
    , name: "Mossy Peaks Haven", img: "QmSZAAFaAbzBTZ6zSYcSGPUnaNQ3WMFPZGggMychBEZrzN"
  },
  818457: {
    rarity: "Rare",
    hp: 2000
    , name: "A Curious Case of WHATIF", img: "QmTSGYYCvSzxSSL7T9EvUgYznGerqtr8q7ADTx9Wi81JGo"
  },
  818258: {
    rarity: "Rare",
    hp: 2000
    , name: "Pawsibilities", img: "Qmeq42t97xpJwibKkBaTji3FZ73kASpDD6geFkuRVBrNET"
  },
  811274: {
    rarity: "Rare",
    hp: 2000
    , name: "Pinewood Estates", img: "QmfVZA5s8x51ZQW96UnZdsDjvt7TALbRM1PFrQReZVVv6X"
  },
  818459: {
    rarity: "Epic",
    hp: 3000
    , name: "Sunsetting Shoebill", img: "QmZ5svCmRY5w5aXtokNJFXqwsiF97rjjnVKPjQqwUUzJS5"
  },
  818259: {
    rarity: "Epic",
    hp: 3000
    , name: "Doggy Dreamhouse", img: "QmYaMaSqDaiV1rVUY5CWSDNJUSz4i2XGFYLzVsTC8AKJ1n"
  },
  811275: {
    rarity: "Epic",
    hp: 3000
    , name: "The Guarded Castle Of Profits", img: "QmQ8tD5F1Qh9QAq3snj8Rr8PfD1t8TgyTMuqPHMEm8zTpF"
  },
  818460: {
    rarity: "Legendary",
    hp: 4000
    , name: "King of What If", img: "QmWg66DJ2SN172EGBW1opHAHifQChZ3cr8EoYjYKUzbZqx"
  },
  818261: {
    rarity: "Legendary",
    hp: 4000
    , name: "Barkitecture of the Future", img: "QmaDZVmA8da5FCoUDdfXShJh5yKMf4jmruwWDwyNtCEmuC"
  },
  811276: {
    rarity: "Legendary",
    hp: 4000
    , name: "WHATIF It Was Evermore Estates", img: "QmTcuqosj43AXFgPmmrLikuuRUUNSPyJiDDpoLxXRGfWzY"
  },
  818462: {
    rarity: "Mystic",
    hp: 5000
    , name: "The Feathered Fortune Teller", img: "QmT6ue3rFs3duaCxnBzqne2jqrYxf3DTsJYPJ3cSoZuSEB"
  },
  818262: {
    rarity: "Mystic",
    hp: 5000
    , name: "The Shrine of Infinite Pawsibilities", img: "QmY3GvkimbVZsDejfzdkh66LUXyGGrwsDP4BsJHdMZEBFh"
  },
  811278: {
    rarity: "Mystic",
    hp: 5000
    , name: "The Timekeeper's Tower", img: "QmTyJv5h2xL8kY9HEPNeJp8ceHLM2TrDgx2ip8kwLBPCdd"
  },
  // Emblem NFTs (Revive Coins)
  886848: {
    revives: 1,
    slot: "Emblem"
    , name: "Gateway Coin", img: "QmfSrMfJfjf8LijAiyx3NVrdduQf56qguuFcoEfpDStKZ7"
  },
  886849: {
    revives: 3,
    slot: "Emblem"
    , name: "Ascension Coin", img: "QmQ6sJDTFaM3GuYujZHBLcn5zNa9PU91Pg2usQzb28mNfF"
  },
  886850: {
    revives: 9,
    slot: "Emblem"
    , name: "Omniverse Coin", img: "QmRNoapuJLw3pSoPhMrC7dvLwzXaATTbYet7jV6R6Ntn8U"
  },
  873626: {
    revives: 25,
    slot: "Emblem",
    onReviveBoost: {
      type: "MP Boost",
      value: 50
      , name: "FIREMAN Founders Ember", img: "QmeZ7xEdvqyUMoEQBzp2jb9fumxeMs7sP7KGTgXknD3Nd7"
    }
  },
  // Gear NFTs (Stat Boosts) --- NOW WITH RARITY ---
  889137: {
    rarity: "Common",
    boostType: "Points Gain",
    boostValue: 5,
    slot: "Crest"
    , name: "Ashen Badge Of Effort", img: "QmdjbYz8ug8TvzegY8aHcAGMnJzrchkC38qe9BiP1Mwvq6"
  },
  889138: {
    rarity: "Uncommon",
    boostType: "Points Gain",
    boostValue: 12.5,
    slot: "Crest"
    , name: "Flare Sigil Of Promise", img: "QmVWDhQhkJERLropa3erNzRyk7e93YmCEe2X9zieJAizBN"
  },
  889139: {
    rarity: "Rare",
    boostType: "Points Gain",
    boostValue: 25,
    slot: "Crest"
    , name: "Crest Of Rising Flame", img: "QmZZdnpjGRt8z8MMeLyTva4PMHuhNsR2Y5mS6QcvbFAs3E"
  },
  889140: {
    rarity: "Epic",
    boostType: "Points Gain",
    boostValue: 50,
    slot: "Crest"
    , name: "Insignia Of Blazing Might", img: "QmVUbg9nQgb7HtnVmAZKrEWbADqo6ca5egv67s1MynoCc5"
  },
  889141: {
    rarity: "Legendary",
    boostType: "Points Gain",
    boostValue: 100,
    slot: "Crest"
    , name: "Ember Crest Of Glory", img: "QmSjGmvsGPdup8XwSuSSWAwvPYUxSDU7TaQUCAqnockGn2"
  },
  889142: {
    rarity: "Mystic",
    boostType: "Points Gain",
    boostValue: 200,
    slot: "Crest"
    , name: "Halo Of The Eternal Flame", img: "QmNrbF8fesq1g7RHRTA7KQV8tJ38XNVT6sLojnKmDEBhtX"
  },
  889143: {
    rarity: "Common",
    boostType: "XP Gain",
    boostValue: 5,
    slot: "Book"
    , name: "Singed Pages Of Memory", img: "QmbE9fc4NfTPL1mZhSmhJgmL9HWNa8hrDyFDvqzXzjotKe"
  },
  889144: {
    rarity: "Uncommon",
    boostType: "XP Gain",
    boostValue: 12.5,
    slot: "Book"
    , name: "Flickering Grimoire", img: "QmSBAbpeNv3frXrMjio5FEonE3hrjWmYzUokKuKsRYTeSa"
  },
  889147: {
    rarity: "Rare",
    boostType: "XP Gain",
    boostValue: 25,
    slot: "Book"
    , name: "Seared Codex Of Insight", img: "QmQzAoXZYAcV3YmnuA43zZpxED9pza4bPZG6Ezv42tNerG"
  },
  889148: {
    rarity: "Epic",
    boostType: "XP Gain",
    boostValue: 50,
    slot: "Book"
    , name: "Volcanic Lexicon Of Lore", img: "QmZ8oERRRnC8HVq7VazrnYUvGgN34uj3tcDKivMbtiVY7x"
  },
  889149: {
    rarity: "Legendary",
    boostType: "XP Gain",
    boostValue: 100,
    slot: "Book"
    , name: "Tome Of Blazing Knowledge", img: "QmTjgng6PnYb8MMxdyBnVktHvTGNdh34TCaQmjWV5GRvZD"
  },
  889150: {
    rarity: "Mystic",
    boostType: "XP Gain",
    boostValue: 200,
    slot: "Book"
    , name: "Grimoire Of The Flame Seer", img: "QmX38gmScwDdgFLqTifKZZyzz5QHxYDfNL9sniJJLsiWkg"
  },
  889153: {
    rarity: "Common",
    boostType: "NFT Gain",
    boostValue: 5,
    slot: "Charm"
    , name: "Coal Trinket Of Chance", img: "QmdDvAmmoUCTTXkbaKuFPsWCTmXLX4TYBgJXqbHBJvqwun"
  },
  889154: {
    rarity: "Uncommon",
    boostType: "NFT Gain",
    boostValue: 12.5,
    slot: "Charm"
    , name: "Ignited Medallion", img: "QmYX4vymENvuAXja49kZD2jBX8qV3XyzhLSCJJ54hypuae"
  },
  889155: {
    rarity: "Rare",
    boostType: "NFT Gain",
    boostValue: 25,
    slot: "Charm"
    , name: "Charm Of The Ember Wind", img: "QmNpyjPD4qa3iRWjPpTg8Ao3HQP1Ua9CBdRFFLa6qrh8pJ"
  },
  889156: {
    rarity: "Epic",
    boostType: "NFT Gain",
    boostValue: 50,
    slot: "Charm"
    , name: "Lucky Flame Relic", img: "QmPrJokFBEUu7QCif91EQ3KsPcAXHn2SWdqvRZf258fUrD"
  },
  889157: {
    rarity: "Legendary",
    boostType: "NFT Gain",
    boostValue: 100,
    slot: "Charm"
    , name: "Charm Of Fortune's Fire", img: "QmTCwU8EMxkcPTPVdTg8AJTfAXQLdyYACJ4MHuuZDjFthM"
  },
  889158: {
    rarity: "Mystic",
    boostType: "NFT Gain",
    boostValue: 200,
    slot: "Charm"
    , name: "Phoenix Eye Talisman", img: "QmVqHcjHo7uXbu9jX8EPaQXbayMensbHvHdWrmpDyNXFwt"
  },
  889078: {
    rarity: "Common",
    boostType: "Stamina Boost",
    boostValue: 5,
    slot: "Boots"
    , name: "Scorched Step Sandals", img: "QmTuh8KY3gjKYrQK5JFJ4uqexDp8ZMxf8sm4VRgHBq4ELJ"
  },
  889079: {
    rarity: "Uncommon",
    boostType: "Stamina Boost",
    boostValue: 12.5,
    slot: "Boots"
    , name: "Ember-Tread Boots", img: "QmQNrY8CwKwR74rJrxcUc81ZhCq3a51Q5u6Phn5E54mota"
  },
  889080: {
    rarity: "Rare",
    boostType: "Stamina Boost",
    boostValue: 25,
    slot: "Boots"
    , name: "Flame-Hardened Boots", img: "QmUs5v2SyEc777VaLoeyxepe7QEVpXKyYf5VSU8G5mLePP"
  },
  889081: {
    rarity: "Epic",
    boostType: "Stamina Boost",
    boostValue: 50,
    slot: "Boots"
    , name: "Magmastride Greaves", img: "QmaS2bSJg9ynCfVEkgsY7kkyhQc1SAD56TLJgnFGRT6HAr"
  },
  889082: {
    rarity: "Legendary",
    boostType: "Stamina Boost",
    boostValue: 100,
    slot: "Boots"
    , name: "Embercore Warboots", img: "QmRoEaHzmvC6nTWWaYakJ9MGG6NKoyoih22ao2gmBxFTEH"
  },
  889083: {
    rarity: "Mystic",
    boostType: "Stamina Boost",
    boostValue: 200,
    slot: "Boots"
    , name: "Solarstride Boots", img: "QmX2NqoYBYSsupLuWYzpgubFrLSD372Q1MNp2ojNwp3yRP"
  },
  889048: {
    rarity: "Common",
    boostType: "Speed Boost",
    boostValue: 5,
    slot: "Shield"
    , name: "Ember-Cracked Buckler", img: "QmRQ6KN1zDWamEUzJjWDgFKGDaHZ6XG4Z3tJg2aNN95anS"
  },
  889049: {
    rarity: "Uncommon",
    boostType: "Speed Boost",
    boostValue: 12.5,
    slot: "Shield"
    , name: "Ember-Runed Shield", img: "QmcKEtspZjsRWm3hMzMgLSXL1E5jAiT5dUkK87zUMyLzH8"
  },
  889050: {
    rarity: "Rare",
    boostType: "Speed Boost",
    boostValue: 25,
    slot: "Shield"
    , name: "Flamewall Aegis", img: "QmUqGMupRwNPW4j2tY6UCrJYHkjf94w6jLxgzEyzLpCfYR"
  },
  889051: {
    rarity: "Epic",
    boostType: "Speed Boost",
    boostValue: 50,
    slot: "Shield"
    , name: "Lava Sentinel Plate", img: "Qme7aw4NjK7rHHkwg5ReBFhmv1v4vSQKhU44bUKmszK8z6"
  },
  889052: {
    rarity: "Legendary",
    boostType: "Speed Boost",
    boostValue: 100,
    slot: "Shield"
    , name: "Firewarden's Wall", img: "QmXTwrG9XN2ppY8JVTujWN1apcxdgUT766MKMh4uozpTR3"
  },
  889053: {
    rarity: "Mystic",
    boostType: "Speed Boost",
    boostValue: 200,
    slot: "Shield"
    , name: "Aegis Of The Flame Sentinel", img: "QmZH3fa88VcamYfi3kju91L5S4oq63Lvx2Ekox4pU5HTLL"
  },
  889015: {
    rarity: "Common",
    boostType: "MP Boost",
    boostValue: 5,
    slot: "Sword"
    , name: "Emberkind Training Sword", img: "QmTSZ4tZw2515M9hUg4HPRqufgURRME4zkKF9QHAPv6x6a"
  },
  889016: {
    rarity: "Uncommon",
    boostType: "MP Boost",
    boostValue: 12.5,
    slot: "Sword"
    , name: "Blade Of The Molten Path", img: "QmSBwbYEAcbnQs3kE9YFvUkPd1KcNWxTSpjbu6sfqg7YPi"
  },
  889017: {
    rarity: "Rare",
    boostType: "MP Boost",
    boostValue: 25,
    slot: "Sword"
    , name: "Inferno Edge", img: "QmTjAkviRvWKr636LyeKFfCTexEdX1iiuq6q7mK5zHoffv"
  },
  889043: {
    rarity: "Epic",
    boostType: "MP Boost",
    boostValue: 50,
    slot: "Sword"
    , name: "Embersteel Flamefang", img: "QmNde4n2R2s67EYRL6NBqv8h2brERxzVjj5SECqTjikFzi"
  },
  889046: {
    rarity: "Legendary",
    boostType: "MP Boost",
    boostValue: 100,
    slot: "Sword"
    , name: "Sword Of Raging Fire", img: "Qmbmkij94XtExrcfWQ9sJCAVAdhsMHTKmeEdx4ZSHpFaQE"
  },
  889047: {
    rarity: "Mystic",
    boostType: "MP Boost",
    boostValue: 200,
    slot: "Sword"
    , name: "Heartblade Of The Fire King", img: "QmSrXB2vzAabbPUdziQ4nQ8T8yCE744R1NpUmnDZ67MHnh"
  },
  // Special Emblems (Equip-only)
  873626: {
    rarity: "Special",
    boostType: "MP Boost",
    boostValue: 50,
    slot: "Emblem",
    name: "Phoenix Emblem",
    img: "QmZKGRq5fPezvqiMgrbfpdrhk3MYJYcqaVgasaSEYBPKrk"
  },
  886849: {
    rarity: "Special",
    boostType: "MP Boost",
    boostValue: 25,
    slot: "Emblem",
    name: "Silver Emblem",
    img: "QmUs5LutY92UPaYW3w5hDiwTNskZLB43J3P5VFWfGqjcmz"
  },
  886848: {
    rarity: "Special",
    boostType: "MP Boost",
    boostValue: 10,
    slot: "Emblem",
    name: "Bronze Emblem",
    img: "QmRP7oMxqYDNM9jP2TuK7nBwqGBZCrHGDYzD4w8itMhgek"
  },
  886850: {
    rarity: "Special",
    boostType: "Points Gain",
    boostValue: 10,
    slot: "Emblem",
    name: "Omniverse Coin",
    img: "QmTCadgYZbov2sKkxnVKA9XNo9M5ZrJb5GtAuawoEfkSTK"
  },
  // Round 3 reissues: same effect as the coin each replaces
  910069: {
    rarity: "Special",
    boostType: "MP Boost",
    boostValue: 25,
    slot: "Emblem",
    name: "Silver Emblem",
    img: "QmUs5LutY92UPaYW3w5hDiwTNskZLB43J3P5VFWfGqjcmz"
  },
  910070: {
    rarity: "Special",
    boostType: "MP Boost",
    boostValue: 10,
    slot: "Emblem",
    name: "Bronze Emblem",
    img: "QmRP7oMxqYDNM9jP2TuK7nBwqGBZCrHGDYzD4w8itMhgek"
  },
  910068: {
    rarity: "Special",
    boostType: "Points Gain",
    boostValue: 10,
    slot: "Emblem",
    name: "Omniverse Coin",
    img: "QmTCadgYZbov2sKkxnVKA9XNo9M5ZrJb5GtAuawoEfkSTK"
  }
};
export const calculateDiminishedBoost = (totalRawBoost) => {
  if (totalRawBoost <= 0) {
    return 0;
  }

  // Diminishing returns removed as per request. Boosts are now linear.
  return totalRawBoost;
};
export const EMBLEM_NAMES = {
  "872658": "Forge Fury",
  "886383": "Workshop Plating",
  "884183": "Bastion Vitality",
  "841646": "Observatory Focus",
  "871245": "Altar Fortune",
  "872679": "Scholar's Wisdom",
  "837486": "Barracks Ration"
};
export const calculateBaseMP = (level) => {
  return Math.floor(500 * Math.pow(1.1, level - 1));
};

export const calculateXpForNextLevel = (level) => Math.floor(1000 * Math.pow(2.0, level - 1));

// Master Account WAX ID - IMPORTANT: This should match the one in your Cloud Function
export const MASTER_ACCOUNT_WAX_ID = "whatifreward";
export const ADMIN_ACCOUNTS = ["whatifreward", "yoyinsoly214"];
export const STAKING_TIERS = {
  'flexible': { apr: 0, lockMonths: 0.5 },
  '1_month': { apr: 15, lockMonths: 1 },
  '3_months': { apr: 25, lockMonths: 3 },
  '6_months': { apr: 50, lockMonths: 6 },
  '12_months': { apr: 100, lockMonths: 12 },
};
export const VAULT_TIERS = {
  'FIREMAN': {
    maxAmount: 250000,
    tiers: [{ amount: 50000, boost: 10 }, { amount: 125000, boost: 25 }, { amount: 250000, boost: 50 }]
  },
  'WHATIF': {
    maxAmount: 15000000,
    tiers: [{ amount: 3000000, boost: 10 }, { amount: 7500000, boost: 25 }, { amount: 15000000, boost: 50 }]
  },
  'WTFBILL': {
    maxAmount: 15,
    tiers: [{ amount: 3, boost: 10 }, { amount: 8, boost: 25 }, { amount: 15, boost: 50 }]
  },
  'WHATIFX': {
    maxAmount: 4000,
    tiers: [{ amount: 800, boost: 10 }, { amount: 2000, boost: 25 }, { amount: 4000, boost: 50 }]
  },
  'WTFWUF': {
    maxAmount: 109000,
    tiers: [{ amount: 21800, boost: 10 }, { amount: 54500, boost: 25 }, { amount: 109000, boost: 50 }]
  },
  'PUZZL': {
    maxAmount: 9000,
    tiers: [{ amount: 1800, boost: 10 }, { amount: 4500, boost: 25 }, { amount: 9000, boost: 50 }]
  },
  'TESTERU': {
    maxAmount: 25000,
    tiers: [
      { amount: 5000, boost: 10 },
      { amount: 12500, boost: 25 },
      { amount: 25000, boost: 50 }
    ]
  },
  'XMASZS': {
    maxAmount: 75,
    tiers: [
      { amount: 15, boost: 10 },
      { amount: 37.5, boost: 25 },
      { amount: 75, boost: 50 }
    ]
  }
};
export const VAULT_TOKEN_INFO = {
  'FIREMAN': { min_stake: 5000, decimals: 5, tiers: VAULT_TIERS.FIREMAN },
  'WHATIF': { min_stake: 1000000, decimals: 8, tiers: VAULT_TIERS.WHATIF },
  'WTFBILL': { min_stake: 1, decimals: 8, tiers: VAULT_TIERS.WTFBILL },
  'WHATIFX': { min_stake: 100, decimals: 8, tiers: VAULT_TIERS.WHATIFX },
  'WTFWUF': { min_stake: 10000, decimals: 8, tiers: VAULT_TIERS.WTFWUF },
  'PUZZL': { min_stake: 1000, decimals: 8, tiers: VAULT_TIERS.PUZZL },
  'TESTERU': { min_stake: 1000, decimals: 8, tiers: VAULT_TIERS.TESTERU },
  'XMASZS': { min_stake: 5, decimals: 6, tiers: VAULT_TIERS.XMASZS },
};
export const VAULT_TOKEN_VALUE = {
  'FIREMAN': 1,
  'WHATIF': 0.01,
  'WTFBILL': 1000,
  'WHATIFX': 10,
  'WTFWUF': 0.4,
  'PUZZL': 0.5,
  'TESTERU': 5,
  'XMASZS': 1000,
};
